import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateStatementPdfSideEffectContext = BaseLoanIdSideEffect.extend({
  paymentDueId: zodBrandedUuid<PaymentDueId>(),
  disableMailTask: z.boolean().optional(),
});
export const GenerateStatementPdfSideEffect = GenerateStatementPdfSideEffectContext.extend({
  type: z.literal('generateStatementPDF'),
});
export type GenerateStatementPdfSideEffect = z.infer<typeof GenerateStatementPdfSideEffect>;
